// extracted by mini-css-extract-plugin
export default {"close_btn":"Header_close_btn__bncwa"};